import { createSlice } from "@reduxjs/toolkit";
import { addToHubspotHandler, addToSalesforceHandler, addToZohoHandler, downloadingCompanyExcel, getCompanyProfileSlug, getFavouriteDetailsHandler, getFavouriteTagsHandler, setEmailAlertHandler, updateFavouriteTagsHandler } from "./bookmark.action";

let initialState = {
  favourites: [],
  favouritesObject: {},
  emailAlert: false,
  companySlug: {},
  addToZoho: false,
  addToHubspot: false,
  isDownload: false,
  duplicateSalesforce: {
    showDuplicateModal: false,
    duplicateCount: 0,
    duplicateData: [],
    fuzzyData: [],
  },
  bookmarkData: {
    data: [],
    loading: true,
  },
};

const bookmarkSlice = createSlice({
  name: "bookmark",
  initialState: { ...initialState },
  reducers: {
    closeSalesforceModal: (state) => {
      state.duplicateSalesforce = { ...initialState.duplicateSalesforce };
    },
    resetBookmarkData: (state) => {
      state.bookmarkData = { ...initialState.bookmarkData };
    },
    loadingBookmarkData: (state) => {
      state.bookmarkData.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateFavouriteTagsHandler.fulfilled, (state, action) => {
      state.favourites = { ...action.payload };
    });
    builder.addCase(getFavouriteTagsHandler.fulfilled, (state, action) => {
      state.favouritesObject = { ...action.payload };
    });
    builder.addCase(setEmailAlertHandler.fulfilled, (state, action) => {
      state.emailAlert = { ...action.payload };
    });
    builder.addCase(getCompanyProfileSlug.fulfilled, (state, action) => {
      state.companySlug = { ...action.payload };
    });
    builder.addCase(addToZohoHandler.fulfilled, (state) => {
      state.addToZoho = true;
    });
    builder.addCase(addToHubspotHandler.fulfilled, (state) => {
      state.addToHubspot = true;
    });
    builder.addCase(downloadingCompanyExcel.fulfilled, (state) => {
      state.isDownload = true;
    });
    builder.addCase(getFavouriteDetailsHandler.fulfilled, (state, action) => {
      if (action?.payload?.type) {
        state.bookmarkData = { ...action.payload.data, data: [...state.bookmarkData.data, ...action.payload.data.data], loading: false };
      } else {
        state.bookmarkData = { ...action?.payload?.data, loading: false };
      }
    });
    builder.addCase(addToSalesforceHandler.fulfilled, (state, action) => {
      state.duplicateSalesforce = {
        showDuplicateModal: true,
        duplicateCount: JSON.parse(action.payload.duplicate_Result).Duplicate_Companies.length,
        duplicateData: JSON.parse(action.payload.duplicate_Result).Duplicate_Companies,
        fuzzyData: JSON.parse(action.payload.fuzzy_Result),
      };
    });
  },
});

export const { closeSalesforceModal, resetBookmarkData, loadingBookmarkData } = bookmarkSlice.actions;

export default bookmarkSlice.reducer;
